import audio0url from '../../assets/audio/it/Punto_00_Darsena_Nuova_ITA_Def.aac';
import audio1url from '../../assets/audio/it/Punto_01_Porto_Mediceo_ITA_Def.aac';
import audio2url from '../../assets/audio/it/Punto_02_Fortezza_Vecchia_e_Darsena_Vecchia_ITA_Def.aac';
import audio3url from '../../assets/audio/it/Punto_03_Monumento_4_Mori_e_Fortezza_Vecchia_ITA_Def.aac';
import audio4url from '../../assets/audio/it/Punto_04_Quartiere_Venezia_ITA_Def.aac';
import audio5url from '../../assets/audio/it/Punto_05_Scali_Rosciano_ITA_Def.aac';
import audio6url from '../../assets/audio/it/Punto_06_Chiesa_e_Convento_dei_Domenicani_ITA_Def.aac';
import audio7url from '../../assets/audio/it/Punto_07_Il_Pontino_ITA_Def.aac';
import audio8url from '../../assets/audio/it/Punto_08_Piazza_della_Repubblica_ITA_Def.aac';
import audio9url from '../../assets/audio/it/Punto_09_Mercato_Centrale_ITA_Def.aac';
import audio10url from '../../assets/audio/it/Punto_10_Chiesa_degli_Olandesi_ITA_Def.aac';
import audio11url from '../../assets/audio/it/Punto_11_Palazzi_dell_800_ITA_Def.aac';
import audio12url from '../../assets/audio/it/Punto_12_Cantina_Palio_Marinaro_ITA_Def.aac';

// punto 0 finocchietti
import audio0_b_url from '../../assets/audio/it/Punto_00_Finocchietti_ITA_Def.aac';
// punto 04 finocchietti è un finale alternativo (quartiere venezia seconda parte)
import audio4_b_url from '../../assets/audio/it/Punto_04_Finocchietti_ITA_Def.aac';
// punto 12 finocchietti è una variante di Cantina Canottieri e Palio
import audio12_b_url from '../../assets/audio/it/Punto_12_Finocchietti_ITA_Def.aac';
// punto welcome
import audioWelcomeUrl from '../../assets/audio/it/Punto_Benvenuto_ITA_Def.aac';

const it = {
  audioWelcome: {
    url: audioWelcomeUrl,
    label: 'Benvenuti'
  },
  audio0: {
    url: audio0url,
    label: 'Darsena Nuova'
  },
  audio1: {
    url: audio1url,
    label: 'Porto Mediceo'
  },
  audio2: {
    url: audio2url,
    label: 'Fortezza Vecchia e Darsena Vecchia'
  },
  audio3: {
    url: audio3url,
    label: 'Monumento 4 Mori e Fortezza Vecchia'
  },
  audio4: {
    url: audio4url,
    label: 'Quartiere Venezia'
  },
  audio5: {
    url: audio5url,
    label: 'Scali Rosciano'
  },
  audio6: {
    url: audio6url,
    label: 'Chiesa e Convento dei Domenicani e Fortezza Nuova'
  },
  audio7: {
    url: audio7url,
    label: 'Il Pontino'
  },
  audio8: {
    url: audio8url,
    label: 'Piazza della Repubblica Parte 1"'
  },
  audio9: {
    url: audio9url,
    label: 'Mercato Centrale'
  },
  audio10: {
    url: audio10url,
    label: 'Chiesa degli Olandesi'
  },
  audio11: {
    url: audio11url,
    label: "I Palazzi dell'800"
  },
  audio12: {
    url: audio12url,
    label: 'Cantina Canottieri Livornesi e Palio Marinaro'
  },
  audio0_b: {
    url: audio0_b_url,
    label: 'Benvenuti e Venezia'
  },
  audio4_b: {
    url: audio4_b_url,
    label: 'Quartiere Venezia II Parte'
  },
  audio12_b: {
    url: audio12_b_url,
    label: 'Cantina Canottieri Livornesi e Palio Marinaro'
  }
};

export default it;